import { Controller } from "stimulus";
import "./bv_opportunity.css";

export default class extends Controller {
  initialize() {}

  connect() {}
}
